export const trialRebuySummary = [
  {
    value: "pv", // 对应tableTotal的字段
    name: "PV",
    tips: true, // 提示的显示隐藏
    tipsName: "活动的累计来访PV", // 提示语
    color: "#EFB37E", // 折线颜色
  },
  {
    value: "uv",
    name: "UV",
    tips: true,
    tipsName: "活动的累计来访UV，多日不去重",
    color: "#B2A8DA",
  },
  {
    value: "joinTimes",
    name: "参与次数",
    tips: true,
    tipsName:
      "符合活动参与行为的用户参与次数汇总，用户可能在活动中参与多次，根据活动类型而定",
    color: "#F4ACB9",
  },
  {
    value: "joinNum",
    name: "参与人数",
    tips: true,
    tipsName:
      "符合活动参与行为的用户数汇总、包括但不限于：抽奖、领奖、分享、签到等，单日去重，多日不去重",
    color: "#F2D0B5",
  },
  {
    value: "avgJoinNum",
    name: "人均参与次数",
    tips: true,
    tipsName: "参与次数/参与人数。",
    color: "#C2CDDE",
  },
  {
    value: "joinRate",
    name: "参与率",
    tips: true,
    tipsName: "参与人数 / UV",
    color: "#96AA08",
  },
  {
    value: "cartTimes",
    name: "加购次数",
    tips: false,
    tipsName: "加购了活动指定商品的累计次数",
    color: "#C2D1C8",
  },
  {
    value: "cartNum",
    name: "加购人数",
    tips: false,
    tipsName: "加购了活动指定商品的累计人数，多日不去重",
    color: "#D39595",
  },
  {
    value: "shareTimes",
    name: "分享次数",
    tips: false,
    tipsName: "活动中进行分享的次数",
    color: "#B8C7F3",
  },
  {
    value: "shareNum",
    name: "分享人数",
    tips: false,
    tipsName: "活动中进行分享的人数，单日去重，多日不去重",
    color: "#8B5A3C",
  },
    {
    value: "trialGiftPayAmt",
    name: "试用礼付款金额",
    tips: true,
    tipsName: "试用礼下单且付款的商品金额（非实付金额）",
    color: "#FF6B6B",
  },
  {
    value: "trialGiftPayItemNum",
    name: "试用礼付款件数",
    tips: true,
    tipsName: "试用礼下单且付款的商品件数",
    color: "#4ECDC4",
  },
  {
    value: "trialGiftPayNum",
    name: "试用礼付款人数",
    tips: true,
    tipsName: "试用礼下单且付款的人数",
    color: "#45B7D1",
  },
  {
    value: "trialGiftActivityPayAmt",
    name: "活动入会试用礼付款金额",
    tips: true,
    tipsName: "通过活动入会，试用礼商品的商品金额（非实付金额）",
    color: "#F7DC6F",
  },
  {
    value: "trialGiftActivityPayItemNum",
    name: "活动入会试用礼付款件数",
    tips: true,
    tipsName: "通过活动入会，试用礼商品付款的商品件数",
    color: "#BB8FCE",
  },
  {
    value: "trialGiftActivityPayNum",
    name: "活动入会试用礼付款人数",
    tips: true,
    tipsName: "通过活动入会，试用礼商品付款的人数",
    color: "#85C1E9",
  },
  {
    value: "trialGiftReceiveAmt",
    name: "试用礼收货金额",
    tips: true,
    tipsName: "试用商品付款且收货的商品金额（非实付金额）",
    color: "#82E0AA",
  },
  {
    value: "trialGiftReceiveItemNum",
    name: "试用礼收货件数",
    tips: true,
    tipsName: "试用商品付款且收货的商品件数",
    color: "#F8C471",
  },
  {
    value: "trialGiftReceiveNum",
    name: "试用礼收货人数",
    tips: true,
    tipsName: "试用商品付款且收货的人数",
    color: "#F1948A",
  },
  {
    value: "trialGiftActivityReceiveAmt",
    name: "活动入会试用礼收货金额",
    tips: true,
    tipsName: "通过活动入会且试用商品收货的商品金额（非实付金额）",
    color: "#AED6F1",
  },
  {
    value: "trialGiftActivityReceiveItemNum",
    name: "活动入会试用礼收货件数",
    tips: true,
    tipsName: "通过活动入会且试用商品收货的商品件数",
    color: "#D7BDE2",
  },
  {
    value: "trialGiftActivityReceiveNum",
    name: "活动入会试用礼收货人数",
    tips: true,
    tipsName: "通过活动入会且试用商品收货的用户",
    color: "#A9DFBF",
  },
  {
    value: "formalGiftPayAmt",
    name: "正装礼付款金额",
    tips: true,
    tipsName: "正装商品付款的商品金额（非实付金额）",
    color: "#FAD7A0",
  },
  {
    value: "formalGiftPayItemNum",
    name: "正装礼付款件数",
    tips: true,
    tipsName: "正装商品付款的件数",
    color: "#F5B7B1",
  },
  {
    value: "formalGiftPayNum",
    name: "正装礼付款人数",
    tips: true,
    tipsName: "正装商品付款的人数",
    color: "#A3E4D7",
  },
  {
    value: "formalGiftActivityPayAmt",
    name: "活动入会正装礼付款金额",
    tips: true,
    tipsName: "通过活动入会，正装商品付款的商品金额（非实付金额）",
    color: "#D5A6BD",
  },
  {
    value: "formalGiftActivityPayItemNum",
    name: "活动入会正装礼付款件数",
    tips: true,
    tipsName: "通过活动入会，完成试用礼付款、正装礼付款的件数",
    color: "#AEB6BF",
  },
  {
    value: "formalGiftActivityPayNum",
    name: "活动入会正装礼付款人数",
    tips: true,
    tipsName: "通过活动入会，正装商品付款的人数",
    color: "#F9E79F",
  },
  {
    value: "formalGiftReceiveAmt",
    name: "正装礼收货金额",
    tips: true,
    tipsName: "正装商品付款且收货的商品金额（非实付金额）",
    color: "#D2B4DE",
  },
  {
    value: "formalGiftReceiveItemNum",
    name: "正装礼收货件数",
    tips: true,
    tipsName: "正装商品付款且收货的商品件数",
    color: "#7FB3D3",
  },
  {
    value: "formalGiftReceiveNum",
    name: "正装礼收货人数",
    tips: true,
    tipsName: "正装商品付款且收货的人数",
    color: "#76D7C4",
  },
  {
    value: "formalGiftActivityReceiveAmt",
    name: "活动入会正装礼收货金额",
    tips: true,
    tipsName: "通过活动入会，正装商品付款且收货的商品金额（非实付金额）",
    color: "#F7DC6F",
  },
  {
    value: "formalGiftActivityReceiveItemNum",
    name: "活动入会正装礼收货件数",
    tips: true,
    tipsName: "通过活动入会，正装商品付款且收货的商品件数",
    color: "#EC7063",
  },
  {
    value: "formalGiftActivityReceiveNum",
    name: "活动入会正装礼收货人数",
    tips: true,
    tipsName: "通过活动入会，正装商品付款且收货的人数",
    color: "#58D68D",
  },
  {
    value: "formalBuyRate",
    name: "付款正装礼率",
    tips: true,
    tipsName: "正装礼付款人数/试用礼付款人数",
    color: "#5DADE2",
  },
  {
    value: "formalEnterBuyRate",
    name: "收货正装礼率",
    tips: true,
    tipsName: "正装礼收货人数/试用礼收货人数",
    color: "#AF7AC5",
  },
  {
    value: "addressFillNum",
    name: "填写收货地址人数",
    color: "#F8D7DA",
  },
]